import React, { useEffect, useState } from 'react';
import '../RequestLive/RequestLive.scss';
import { Controller, useForm } from 'react-hook-form';
import ErrorMessage from '../../../shared/FormComponents/ErrorMessage/ErrorMessage';
import DIContainer from '../../../../config/di.container';
import LocalStorageService from '../../../../services/local.storage.service';
import DITYPES from '../../../../config/di.types';
import Dropdown from "../../../shared/FormComponents/CustomDropdown/CustomDropdown";
import OnBoardingLookupService from '../../../../services/OnboardingService';
import { userDetailsLocalStorageKey, websiteRegex } from '../../../../common/constant';
import GoLiveCreateRequest from '../../../../common/model/GoLiveCreateRequest';
import UserDetails from '../../../../common/model/UserDetails';
import { EErrorType } from '../../../../common/enum/EErrorType';
import NotificationService from '../../../../services/NotificationService';
import language from '../../../../util/en';
import '../../Onboarding.scss';
import BillingDetails from '../RequestLive/BillingDetails/BillingDetails';
import CreditCardDetails from '../RequestLive/CreditCardDetails/CreditCardDetails';
import ActivateBillingAccountRequest from '../../../../common/model/ActivateBillingAccountRequest';

let notificationService: NotificationService = DIContainer.get<NotificationService>(DITYPES.NotificationService);
export interface IRequestLiveProp {
    handleOnChange: any;
    handleSubmit: any;
}

type RequiredFields = {
    firstName: string;
    lastName: string;
    businessName: string;
    website: string;
    applicationName: string;
    billingFirstName: string;
    billingLastName: string;
    billingAddress1: string;
    ccfirstName: string;
    cclastName: string;
    ExpMonth: string;
    ExpYear: string;
    cvv: string;
};

const onboardingLookupService = DIContainer.get<OnBoardingLookupService>(DITYPES.OnboardingLookupService);
const localStorageService = DIContainer.get<LocalStorageService>(DITYPES.LocalstorageService);
const RequestLive: React.FC<IRequestLiveProp> = (props) => {

    const { register, watch, control, handleSubmit, setValue, trigger, formState: { errors } } = useForm();

    const [languages, setLanguages] = useState<any[]>();
    const [isSubmitButtonDisabled, setSubmitButtonDisabled] = useState<boolean>(false);
    const [isWebsiteDisabled, setIsWebsiteDisabled] = useState<boolean>(false);


    //Set form validation//
    let requestLiveForm: any = {
        firstName: {
            Label: "First name",
            FieldName: "firstName",
            ValidationAndEvent: { required: true, onChange: (e) => { onChangeHandler(e) }, onBlur: (e) => { onChangeHandler(e) } }
        },
        lastName: {
            Label: "Last name",
            FieldName: "lastName",
            ValidationAndEvent: { required: true, onChange: (e) => { onChangeHandler(e) }, onBlur: (e) => { onChangeHandler(e) } }

        },
        businessName: {
            Label: "Business name",
            FieldName: "businessName",
            ValidationAndEvent: { required: true, onChange: (e) => { onChangeHandler(e) }, onBlur: (e) => { onChangeHandler(e) } }
        },
        website: {
            Label: "Website",
            FieldName: "website",
            ValidationAndEvent: { required: true, pattern: websiteRegex, onChange: (e) => { onChangeHandler(e) }, onBlur: (e) => { onChangeHandler(e) } }
        },
        applicationName: {
            Label: "Application/Integration name",
            FieldName: "applicationName",
            ValidationAndEvent: { required: true, onChange: (e) => { onChangeHandler(e) }, onBlur: (e) => { onChangeHandler(e) } }
        },
        description: {
            Label: "Give us a brief description of the integration you’re building",
            FieldName: "description",
            ValidationAndEvent: { required: true, onChange: (e) => { onChangeHandler(e) }, onBlur: (e) => { onChangeHandler(e) } }
        },
        existingBusiness: {
            Label: "Are there any businesses using Mindbody that you are working with presently?",
            FieldName: "existingBusiness",
            ValidationAndEvent: { required: true, onChange: (e) => { onChangeHandler(e) }, onBlur: (e) => { onChangeHandler(e) } }
        },
        language: {
            Label: "Primary platform/language",
            FieldName: "language"
        }
    }

    useEffect(() => {
        const subscription = watch((value, { name, type }) => {
            const { billingCompany, ...newObj } = value;
            updateProgessBar(newObj as RequiredFields);
        });
        return () => subscription.unsubscribe();

    }, [watch]);


    useEffect(() => {
        getInitialUserDetailsFromLocal();
        window.scrollTo(0, 0);

        (async () => {
            loadrequestLiveForm();
        })();
    }, [])

    const getInitialUserDetailsFromLocal = () => {
        var userDetails: UserDetails = new UserDetails();
        Object.assign(userDetails, JSON.parse(localStorageService.get(userDetailsLocalStorageKey) || '{}'));

        setValue("firstName", userDetails.FirstName);
        setValue("lastName", userDetails.LastName);
        setValue("businessName", userDetails.BusinessName);
        setValue("billingFirstName", userDetails.FirstName);
        setValue("billingLastName", userDetails.LastName);
        if (userDetails.Website) {
            setValue("website", userDetails.Website);
            setIsWebsiteDisabled(true);
        }
    }

    const loadrequestLiveForm = async () => {
        if (!languages) {
            await getLanguageFromService();
        }
    }

    const getLanguageFromService = async () => {
        let languages = await onboardingLookupService.getLanguages();
        setLanguages(languages);
    }

    const updateProgessBar = (reqFileds: RequiredFields) => {
        const emptyValues = new Set(["", null, undefined]);
        let count = (80 / Object.keys(reqFileds).length) *
            (Object.keys(reqFileds).length - Object.values(reqFileds).filter(x => emptyValues.has(x)).length);
        props.handleOnChange("GoLiveForm", count)
    }

    const onSubmit = async (data) => {
        setSubmitButtonDisabled(true);
        var response = await onboardingLookupService.createGoLiveRequest(mapGoLiveRequest(data));
        if (response) {
            notificationService.notifyToster("Live data access requested successfully!", EErrorType.SUCCESS)
            props.handleSubmit("GoLiveForm", 100);
        }
        setSubmitButtonDisabled(false);
    };

    const mapGoLiveRequest = (data): GoLiveCreateRequest => {
        var request = new GoLiveCreateRequest()
        request.ApplicationName = data.applicationName;
        request.BusinessName = data.businessName;
        request.ClientList = data.existingBusiness;
        request.FirstName = data.firstName;
        request.LastName = data.lastName;
        request.PlatformLanguage = data.language;
        request.UsageDesc = data.description;
        request.Website = data.website;
        request.IntegrationType = "Not Mentioned";
        request.BillingDetails = getActivateBillingAccountRequest(data);
        return request;
    }

    const onChangeHandler = (event) => {
        trigger(event.target.name);
    }

    const getActivateBillingAccountRequest = (data: any) => {
        var activateBillingAccountRequest = new ActivateBillingAccountRequest();
        activateBillingAccountRequest.BillingAddress1 = data.billingAddress1;
        activateBillingAccountRequest.BillingCity = data.billingCity;
        activateBillingAccountRequest.BillingPostalCode = data.billingPostalCode;
        activateBillingAccountRequest.CCFirstName = data.firstName;
        activateBillingAccountRequest.CCLastName = data.lastName;
        activateBillingAccountRequest.CCNumber = data.ccNumber;
        activateBillingAccountRequest.CVV = data.cvv;
        activateBillingAccountRequest.Company = data.businessName;
        activateBillingAccountRequest.Country = data.billingCountry;
        activateBillingAccountRequest.Email = data.billingEmail;
        activateBillingAccountRequest.ExpMonth = data.expMonth;
        activateBillingAccountRequest.ExpYear = data.expYear;
        activateBillingAccountRequest.FirstName = data.billingFirstName;
        activateBillingAccountRequest.LastName = data.billingLastName;
        activateBillingAccountRequest.Phone = data.billingPhone.replace(/[^ +-+a-zA-Z0-9]/g, '').replace(/([^\s]*\s[^\s]*)\s/g, "$1").replace(/([^\s]*\s[^\s]*)\s/g, "$1");
        activateBillingAccountRequest.StateProv = data.billingStateProv;

        return activateBillingAccountRequest
    }

    return (
        <div>
            <div className="request-live-container">
                <span className="ob-heading">Request Live Data Access</span>
                <div className="request-live-text">Please allow up to 2 business days for us to verify your account.</div>
                <div className="request-live-acc-text">Account Information</div>
                <div className="request-live-form">
                    <form onSubmit={handleSubmit(onSubmit)}>
                        <div className="d-flex">
                            {requestLiveForm.firstName &&
                                <div className="wd-100">
                                    <label className="request-live-label">{requestLiveForm.firstName.Label}*</label>
                                    <input
                                        {...register(requestLiveForm.firstName.FieldName, requestLiveForm.firstName.ValidationAndEvent)}
                                        disabled={true} className="first-name-input disabled-field" type="text" maxLength={25}
                                        id="ob-rl-first-name" name="firstName"
                                    ></input>
                                    <ErrorMessage errors={errors} {...requestLiveForm.firstName}></ErrorMessage>
                                </div>
                            }
                            {requestLiveForm.lastName &&
                                <div className="last-name-div wd-100">
                                    <div className="last-name-container">
                                        <label className="request-live-label">{requestLiveForm.lastName.Label}*</label>
                                        <input {...register(requestLiveForm.lastName.FieldName, requestLiveForm.lastName.ValidationAndEvent)}
                                            maxLength={25} disabled={true} className="last-name-input disabled-field" type="text" id="ob-rl-last-name"
                                        >
                                        </input>
                                        <ErrorMessage errors={errors} {...requestLiveForm.lastName}></ErrorMessage>
                                    </div>
                                </div>
                            }
                        </div>
                        <div className="d-flex padding-top-32">
                            {requestLiveForm.businessName &&
                                <div className="wd-100">
                                    <label className="request-live-label">{requestLiveForm.businessName.Label}*</label>
                                    <input {...register(requestLiveForm.businessName.FieldName, requestLiveForm.businessName.ValidationAndEvent)}
                                        maxLength={50} disabled={true} className="first-name-input disabled-field" type="text"  id="ob-rl-business-name"
                                    >

                                    </input>
                                    <ErrorMessage errors={errors} {...requestLiveForm.businessName}></ErrorMessage>
                                </div>
                            }
                            {requestLiveForm.website &&
                                <div className="last-name-div wd-100">
                                    <div className="last-name-container">
                                        <label className="request-live-label">{requestLiveForm.website.Label}*</label>
                                        <input {...register(requestLiveForm.website.FieldName, requestLiveForm.website.ValidationAndEvent)}
                                            maxLength={50} disabled={isWebsiteDisabled} className={"last-name-input " + (isWebsiteDisabled ? 'disabled-field' : '')} type="text"  id="ob-rl-website"
                                        ></input>
                                        <ErrorMessage errors={errors} ignoreLabel={true} requiredMessage={language.createAccount.WebsiteReqError} {...requestLiveForm.website} message={language.createAccount.ValidURLMessage}></ErrorMessage>
                                    </div>
                                </div>
                            }
                        </div>
                        <div className="about-int-secton">
                            <span className="about-sec-header">About Your Mindbody Integration</span>
                            {requestLiveForm.applicationName &&
                                <div className="padding-top-32">
                                    <label className="request-live-label">{requestLiveForm.applicationName.Label}*</label>
                                    <input {...register(requestLiveForm.applicationName.FieldName, requestLiveForm.applicationName.ValidationAndEvent)}
                                        maxLength={50} autoComplete="disabled" className="business-name-input" type="text"  id="ob-rl-application-name"
                                        name="applicationName"
                                    ></input>
                                    <ErrorMessage errors={errors} {...requestLiveForm.applicationName}></ErrorMessage>
                                </div>
                            }
                            {requestLiveForm.description &&
                                <div className="padding-top-32">
                                    <label className="request-live-label">{requestLiveForm.description.Label}*</label>
                                    <textarea {...register(requestLiveForm.description.FieldName, requestLiveForm.description.ValidationAndEvent)}
                                        placeholder="Enter your text here..." className="description-text-area" id="ob-rl-description"></textarea>
                                    <ErrorMessage errors={errors} {...requestLiveForm.description} ignoreLabel={true}></ErrorMessage>
                                </div>
                            }
                            {requestLiveForm.existingBusiness &&
                                <div className="padding-top-32">
                                    <label className="request-live-label">{requestLiveForm.existingBusiness.Label}*</label>
                                    <input {...register(requestLiveForm.existingBusiness.FieldName, requestLiveForm.existingBusiness.ValidationAndEvent)}
                                        maxLength={100} autoComplete="off" className="business-name-input" type="text" id="ob-rl-existing-Business"></input>
                                    <ErrorMessage errors={errors} {...requestLiveForm.existingBusiness} ignoreLabel={true}></ErrorMessage>
                                </div>
                            }
                            {languages && languages.length > 0 &&
                                <div className="padding-top-32">
                                    {/* @ts-ignore */}
                                    <Controller
                                        control={control}
                                        name="language"
                                        rules={{ required: true }}
                                        render={(
                                            { field: { onChange, value, ref, ...field },
                                                fieldState: { invalid }
                                            }) => (
                                            <Dropdown
                                                {...field}
                                                data={languages}
                                                id="language"
                                                value={value}
                                                changeFunc={onChange}
                                                label={`${requestLiveForm.language.Label}*`}
                                                controlId="languageControlId"
                                                isCheckMark
                                                error={invalid}
                                            />
                                        )}
                                    />
                                </div>
                            }
                        </div>
                        <div>
                            {register &&
                                <div>
                                    <BillingDetails control={control} trigger={trigger} setValue={setValue}
                                        register={register} onChangeHandler={onChangeHandler} errors={errors} />
                                    <CreditCardDetails control={control} register={register} onChangeHandler={onChangeHandler}
                                        errors={errors} />
                                </div>
                            }
                            <div>
                                <a id="ob-rl-pricelink" className="pricing-link" target="_blank" href="/#landingPricing">Monthly pricing for our APIs</a>
                            </div>
                            <div>
                                <input id="ob-requestlive-btn" disabled={isSubmitButtonDisabled} type="submit" value="Continue" className="btn team3-left-button register w-button request-live-continue-button" />
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    );
}
export default RequestLive;